// extracted by mini-css-extract-plugin
export default {"addCompanyContainer":"AddCompany_addCompanyContainer__+F8T2","addCompanyCard":"AddCompany_addCompanyCard__jl4Lo"};